module.exports = __webpack_public_path__ + "static/media/logo.df555fcf.png";